"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BurgerMenuTab = require("./BurgerMenuTab");
Object.keys(_BurgerMenuTab).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BurgerMenuTab[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BurgerMenuTab[key];
    }
  });
});
